import { FunctionComponent } from 'react'
import {
  colors,
  rucksack,
  Box,
  CircularProgress,
  Typography,
} from '@black-bear-energy/rucksack'
import { FieldLabel } from './FieldLabel'

export const DocumentCircularProgress: FunctionComponent<
  DocumentCircularProgressProps
> = ({ variant, numerator, denominator }) => {
  let value: number | undefined
  let isDeterminate = false
  if (typeof numerator === 'number' && typeof denominator === 'number') {
    value = (numerator / denominator) * 100
    isDeterminate = true
  }
  const variantProps: Record<
    'required' | 'verified' | 'additional',
    {
      numeratorColor: string
      denominatorColor: string
      label: string
    }
  > = {
    required: {
      numeratorColor: rucksack.palette.warning.main,
      denominatorColor: rucksack.palette.warning.outlinedBorder,
      label: 'Required',
    },
    verified: {
      numeratorColor: rucksack.palette.success.main,
      denominatorColor: rucksack.palette.success.outlinedBorder,
      label: 'Verified',
    },
    additional: {
      numeratorColor: colors.blueGrey[600],
      denominatorColor: colors.blueGrey[200],
      label: 'Additional',
    },
  }

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1,
      }}
    >
      <Box sx={{ position: 'relative', display: 'inline-flex' }}>
        <CircularProgress
          variant="determinate"
          value={100}
          sx={{
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
            position: 'absolute',
            color: variantProps[variant].denominatorColor,
            opacity: 0.75,
          }}
        />
        <CircularProgress
          variant={isDeterminate ? 'determinate' : 'indeterminate'}
          value={value}
          sx={{
            color: variantProps[variant].numeratorColor,
          }}
        />
        <Box
          sx={{
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
            position: 'absolute',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Typography variant="caption">
            {isDeterminate ? `${numerator}/${denominator}` : ''}
          </Typography>
        </Box>
      </Box>
      <FieldLabel label={variantProps[variant].label} />
    </Box>
  )
}

interface DocumentCircularProgressProps {
  variant: 'required' | 'verified' | 'additional'
  numerator?: number
  denominator?: number
}
